
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offline/centres/subscribe/[[...id]]",
      function () {
        return require("private-next-pages/offline/centres/subscribe/[[...id]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offline/centres/subscribe/[[...id]]"])
      });
    }
  